module.exports = __webpack_public_path__ + "img/avatar5.95a5574a.png";